module.exports = __webpack_public_path__ + "static/media/tableTennis.0fc0da2a.png";